/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 jaw.glb 
*/

import React, { useRef } from 'react'
import { useGLTF, Outlines } from '@react-three/drei'
import * as THREE from 'three'

const BASE = import.meta.env.BASE_URL

export default function Model(props) {
  const { nodes } = useGLTF(`${BASE}biteback/models/jaw.glb`)

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.BearTrap_Closed.geometry}
        rotation={[2.13, -1.526, 0.469]}
        scale={1.21}
        castShadow
        receiveShadow
      >
        {/* White standard material */}
        <meshStandardMaterial
          color={'white'}
          metalness={0.0}
          roughness={0.35}
          flatShading={false}
          vertexColors={false}   // ignore any vertex colors baked into the glb
          toneMapped={true}      // or =false if your tone mapping is washing colors out
          transparent={true}
        />

        {/* Stylized outlines */}
              <Outlines thickness={0.04} color={'#000000'} screenspace/>
      </mesh>
    </group>
  )
}

useGLTF.preload(`${BASE}biteback/models/jaw.glb`)
